module.exports = __webpack_public_path__ + "img/login-left.1db09ac0.png";